<template>
  <v-dialog v-model="dialog" max-width="480px">
    <v-card>
      <v-card-title class="mx-3">
        {{ addMemo ? $t("CRUD.complete", [label]) : $t("$vuetify.alert") }}
        <v-spacer></v-spacer>
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" @click="dialog = false">
              fa-times
            </v-icon>
          </template>
          {{ $t("$vuetify.close") }}
        </v-tooltip>
      </v-card-title>
      <v-divider />
      <v-card-text class="pa-8 text-center subtitle-1" v-if="addMemo">
        <v-textarea v-model="memo" auto-grow outlined />
      </v-card-text>  
      <v-card-text class="pa-8 text-center subtitle-1" v-else>
        {{ $t("CRUD.complete", [label]) }}
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="secondary" outlined @click="dialog = false">
          {{ $t("$vuetify.close") }}
        </v-btn>
        <v-btn color="accent" depressed @click="$emit('confirm', memo)">
          {{ $t("$vuetify.confirm") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "DialogDelete",

  props: {
    value: Boolean,
    label: String,
    billCheckMemo: String,
    addMemo: Boolean,
  },

  data: () => ({
    dialog: false,
    memo: "",
  }),

  watch: {
    value: {
      immediate: true,
      handler() {
        this.dialog = this.value;
        this.memo = this.billCheckMemo ? this.billCheckMemo : "";
      },
    },
    dialog: {
      handler() {
        this.$emit("input", this.dialog);
        if (!this.dialog) this.$emit("close");
      },
    },
  },
};
</script>
